import * as actions from "app/application/actions";
import { initialApplication } from "app/application/Application";
import { USER_FETCH_DATA, USER_SET_DATA } from "user/user/actions";
//-- Reducer -------------------------------------------------------------------------------------------------------------------------------
const applicationReducer = (currState = initialApplication, baseAction) => {
    let stateChanges;
    switch (baseAction.type) {
        case USER_FETCH_DATA:
            return Object.assign(Object.assign({}, currState), { isFetchingUserData: true });
        case USER_SET_DATA:
            return Object.assign(Object.assign({}, currState), { isFetchingUserData: false });
        case actions.LOADING:
            const loadingAction = baseAction;
            return Object.assign(Object.assign({}, currState), { isFullScreenLoading: loadingAction.isLoading });
        case actions.AUTHENTICATION:
            const authenticationAction = baseAction;
            return Object.assign(Object.assign({}, currState), { isAuthenticatedToView: authenticationAction.isAuthenticated });
        case actions.AUTHORISATION:
            const authorisationAction = baseAction;
            return Object.assign(Object.assign({}, currState), { isAuthorisedToView: authorisationAction.isAuthorised });
        case actions.ERROR:
            const errorAction = baseAction;
            return Object.assign(Object.assign({}, currState), { isErrorView: errorAction.isInError });
        case actions.MAINTENANCE:
            const maintenanceAction = baseAction;
            return Object.assign(Object.assign({}, currState), { isFetchingUserData: false, isUnderMaintenanceView: maintenanceAction.isUnderMaintenance, underMaintenanceMessage: maintenanceAction.underMaintenanceMessage });
        case actions.SHOW:
            return Object.assign(Object.assign({}, currState), { isFullScreenLoading: false, isAuthenticatedToView: true, isAuthorisedToView: true, isErrorView: false, isUnderMaintenanceView: false });
    }
    return currState;
};
export default applicationReducer;
